import React from "react";
import { Button, Text, Tooltip } from "@telia/teddy";
import { useDispatch, useSelector } from "react-redux";
import { getActiveSubscription } from "../../../../checkout/state/selectors/cartSelectors";
import { nextSubscriptionStep, prevSubscriptionStep } from "../../../state/actions/subscriptionStepsActions";
import "./SubscriptionStepsControls.less";

interface Props {
    backLabel?: string;
    hideBack?: boolean;
    isProcessing?: boolean;
    nextButton?: React.ReactNode;
    nextButtonId?: string;
    nextLabel?: string;
    onPrimaryClick?: () => void | Promise<void>;
    onSecondaryClick?: () => void | Promise<void>;
    primaryDisabled?: boolean;
    primaryTooltip?: string;
}

const SubscriptionStepsControls = ({
    onSecondaryClick,
    onPrimaryClick,
    isProcessing = false,
    hideBack = false,
    nextLabel = "Neste",
    backLabel = "Tilbake",
    nextButton,
    nextButtonId,
    primaryDisabled = false,
    primaryTooltip,
}: Props) => {
    const activeSubscription = useSelector(getActiveSubscription);
    const dispatch = useDispatch();

    const handleBack = async () => {
        if (onSecondaryClick) {
            await onSecondaryClick();
        } else {
            if (!activeSubscription) return;
            dispatch(prevSubscriptionStep(activeSubscription));
        }
    };

    const handleNext = async () => {
        if (onPrimaryClick) {
            await onPrimaryClick();
        } else {
            if (!activeSubscription) return;
            dispatch(nextSubscriptionStep(activeSubscription));
        }
    };

    const primaryButton = (
        <Button
            autoFocus={!primaryTooltip}
            id={nextButtonId}
            className="subscription-steps-controls__button"
            variant="primary"
            onClick={handleNext}
            disabled={isProcessing || primaryDisabled}
            loading={isProcessing}
            style={primaryTooltip ? { pointerEvents: "none" } : undefined}
        >
            <span>{nextLabel}</span>
        </Button>
    );

    const primaryButtonWithTooltip = primaryTooltip ? (
        <Tooltip>
            <Tooltip.Trigger asChild>
                <span style={{ display: "inline-block" }}>{primaryButton}</span>
            </Tooltip.Trigger>
            <Tooltip.Content>
                <Text>{primaryTooltip}</Text>
            </Tooltip.Content>
        </Tooltip>
    ) : (
        primaryButton
    );

    return (
        <div className="subscription-steps-controls">
            {!hideBack && (
                <Button
                    className="subscription-steps-controls__button subscription-steps-controls__button--back"
                    variant="secondary"
                    onClick={handleBack}
                    disabled={isProcessing}
                >
                    <span>{backLabel}</span>
                </Button>
            )}
            {nextButton ?? primaryButtonWithTooltip}
        </div>
    );
};

export default SubscriptionStepsControls;
